import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Body, Footer, Popup } from '@calendly/ui/components/popup'
import { useSelector } from 'react-redux'

import { useBooleanState } from 'hooks/useBooleanState'
import {
  conflictingEventTypesPresentSelector,
  conflictingEventTypesSelector,
  workflowIsCreatedSelector
} from 'selectors/workflows'

import { EventTypeList } from './event_type_list'

export const NewWorkflowPopup = () => {
  const [isOpen, _openPopup, closePopup] = useBooleanState(true)
  const hasConflicts = useSelector(conflictingEventTypesPresentSelector)
  const conflictingEventTypes = useSelector(conflictingEventTypesSelector)
  const workflowIsCreated = useSelector(workflowIsCreatedSelector)

  if (!(workflowIsCreated && hasConflicts)) {
    return null
  }

  return (
    <Popup
      isOpen={isOpen}
      onClose={closePopup}
      title={I18n.t('publisher.workflows.list.conflicts_modal.title')}
    >
      <Body>
        <p>
          {HtmlParser(I18n.t('publisher.workflows.list.conflicts_modal.message'))}
        </p>
        <EventTypeList eventTypes={conflictingEventTypes} />
      </Body>
      <Footer>
        <Button onClick={closePopup}>
          {I18n.t('publisher.action.got_it')}
        </Button>
      </Footer>
    </Popup>
  )
}
